export default __webpack_public_path__ + "static/media/illustration-risk_debt.cb354977.png";